import React from 'react';
import "../../styles/Css/TermsOfService.css";

const TrustSecurity = () => {
    const navItems = [
        { id: "data-minimization", label: "1. Data Minimization" },
        { id: "secure-infrastructure", label: "2. Secure Infrastructure" },
        { id: "AI-transparency", label: "3. AI Transparency" },
        { id: "compliance", label: "4. Platform Compliance" },
        { id: "auditability", label: "5. Auditability" },
        { id: "continuous-improvement", label: "6. Continuous Improvement" },
    ];

    return (
        <div className="legal-page">
            <section className="legal-hero">
                <div className="container">
                    <span className="legal-badge">Security & Compliance</span>
                    <h1 className="legal-hero__title">Trust Center</h1>
                    <p className="legal-subtitle">Our commitment to protecting your data and ensuring AI transparency.</p>
                    <div className="last-updated">Last Updated: March 2024</div>
                </div>
            </section>

            <section className="legal-content section">
                <div className="container legal-grid">
                    {/* Sticky Sidebar */}
                    <aside className="legal-sidebar">
                        <div className="sidebar-sticky">
                            <p className="sidebar-title">On this page</p>
                            <nav>
                                <ul>
                                    {navItems.map(item => (
                                        <li key={item.id}>
                                            <a href={`#${item.id}`}>{item.label}</a>
                                        </li>
                                    ))}
                                    <li>
                                        <a href="#contact" className="sidebar-contact-link">Contact Support</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </aside>

                    <div className="legal-document">
                        <div className="highlight-box">
                            <p><strong>Trust is our foundation.</strong> Deal To Close (AI) Pvt Ltd is built to meet the rigorous expectations of real estate professionals and enterprise partners through strong data protection and operational reliability.</p>
                        </div>

                        <h2 id="data-minimization">Data Minimization and Purpose Limitation</h2>
                        <p>
                            We collect and process only the data strictly required to deliver our features. Access to connected services (such as email or calendar) is limited to user-approved scopes. <strong>Your data is never used for advertising, nor is it ever sold to third parties.</strong>
                        </p>

                        <h2 id="secure-infrastructure">Secure Infrastructure</h2>
                        <p>
                            We leverage industry-leading cloud infrastructure featuring:
                        </p>
                        <ul className="legal-list">
                            <li>AES-256 encryption for data at rest.</li>
                            <li>TLS 1.2+ for all data in transit.</li>
                            <li>Continuous security monitoring and automated vulnerability scanning.</li>
                            <li>Strict Principle of Least Privilege (PoLP) for internal access.</li>
                        </ul>

                        <h2 id="AI-transparency">AI Transparency</h2>
                        <p>
                            Our AI assists with document analysis and task automation, but it is never "autopilot."
                        </p>
                        <ul className="legal-list">
                            <li>AI does not make binding legal decisions.</li>
                            <li>Users must review and approve AI-generated summaries or actions.</li>
                            <li>We provide clear indicators whenever content is AI-generated.</li>
                        </ul>

                        <h2 id="compliance">Compliance with Platform Policies</h2>
                        <p>Deal To Close (AI) Pvt Ltd strictly complies with global platform standards:</p>
                        <ul className="legal-list">
                            <li><strong>Google API Services:</strong> Full adherence to the User Data Policy, including Limited Use requirements.</li>
                            <li><strong>Microsoft Partner Center:</strong> Compliance with Microsoft platform and security requirements.</li>
                            <li><strong>Privacy Laws:</strong> Alignment with applicable data protection regulations (GDPR/CCPA frameworks).</li>
                        </ul>

                        <h2 id="auditability">Auditability and Accountability</h2>
                        <p>
                            We maintain comprehensive activity logs. This ensures that every action taken within the platform can be audited for compliance, providing our enterprise partners with the transparency required for institutional oversight.
                        </p>

                        <h2 id="continuous-improvement">Continuous Improvement</h2>
                        <p>
                            Security is not a static goal. We conduct regular internal audits and update our privacy practices to stay ahead of emerging threats and evolving regulatory landscapes.
                        </p>

                        <hr className="section-divider" />

                        <h2 id="contact">Contact Information</h2>
                        <div className="contact-card">
                            <p>Have questions about our security protocols or data handling? Our legal and security teams are here to help.</p>
                            <div className="contact-details">
                                <div className="contact-item">
                                    <strong>Deal to Close AI</strong>
                                    <p>123 Tech Drive, San Francisco, CA 94105</p>
                                </div>
                                <div className="contact-item">
                                    <strong>Legal Inquiries</strong>
                                    <a href="mailto:legal@dealtoclose.ai">legal@dealtoclose.ai</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TrustSecurity;